<template>
    <div class="popup">
        <van-popup :value="show" @click-overlay="close">
            <div class="content">
                <statusBar></statusBar>
                <div class="header">
                    <div>{{ $t("Withdraw.InsertPassword") }}</div>
                    <div class="close">
                        <i class="iconfont icon-s-cuowu-guanbi" @click="close"></i>
                    </div>
                </div>
                <div class="info_box">
                    <div class="withdral_input_item">
                        <div class="input_title">
                            {{ $t('Withdraw.WithdrawPassword') }}
                            <div class="eyes" @click.stop="isPwd1Dot = !isPwd1Dot">
                                <img v-if="isPwd1Dot" src="@/assets/withdraw/icon_eyes.png" mode="aspectFit" />
                                <img v-else src="@/assets/withdraw/icon_eyesAct.png" mode="aspectFit" />
                            </div>
                        </div>
                        <code-input v-model="formData.withdrawPassword" mode="box" :space="0" :maxlength="6" hairline
                            color="#fffafe" :dot="isPwd1Dot" size="48"></code-input>
                    </div>
                    <div class="withdraw_Tips">
                        <div class="Tips">{{ $t("Withdraw.withdrawPwdPopupTips") }}</div>
                        <div class="forget_txt" @click.stop="toWithdrawPwd">{{
                            $t('login.ForgetPassword') }}</div>
                    </div>
                </div>
                <div class="action_btn" @click="handleWithdraw">
                    <span>{{ $t("lang.confirm") }}</span>
                </div>
            </div>
        </van-popup>
    </div>
</template>

<script>
import statusBar from '@/components/statusBar'
import codeInput from '@/components/codeInput'
import { verifyWithdrawPassword } from '@/api/withdraw'
import { Toast } from 'vant'
import md5 from 'md5'
import { deepClone } from '@/utils'
export default {
    name: 'changePwd',
    components: { codeInput, statusBar },
    data() {
        return {
            show: false,
            isFocus: 0,
            formData: {},
            canCallHandleWithDraw: true,
            showPassword: false,
            isPwd1Dot: true
        }
    },
    methods: {
        open() {
            this.show = true
        },
        close() {
            this.formData = {}
            this.show = false
        },
        handleWithdraw() {
            if (this.canCallHandleWithDraw) {
                this.canCallHandleWithDraw = false

                if (!this.formData.withdrawPassword) {
                    Toast(this.$t('Withdraw.PleaseEnterWithdrawPassword'))
                    this.canCallHandleWithDraw = true
                    return
                }
                if (this.loading) {
                    return
                }
                const form = deepClone(this.formData)
                form.withdrawPassword = md5(form.withdrawPassword)
                verifyWithdrawPassword(form, { custom: { toast: false } }).then(res => {
                    if (!res.code && !this.canCallHandleWithDraw) {
                        this.formData.pwd1 = this.formData.withdrawPassword
                        this.formData.pwd2 = this.formData.withdrawPassword
                        const pwdForm = encodeURIComponent(JSON.stringify(this.formData))
                        this.$store.dispatch('user/setWithdrawPwdForm', pwdForm)
                        this.formData.withdrawPassword = ''
                        this.$emit('WithDrawSucc', res)
                        this.close()
                    } else {
                        Toast(res.message)
                    }
                }).finally(() => {
                    this.canCallHandleWithDraw = true
                })
            }
        },
        toWithdrawPwd() {
            this.close()
            this.$store.dispatch('user/setIsShowBankSetPopup', false)
            this.$store.dispatch('user/setIsShowWithdrawPopup', false)
            this.$store.dispatch('user/setIsShowWithdrawPwdSetPopup', true)
        }
    }
}
</script>

<style scoped lang="scss">
@import '@/common/styles/viriables.scss';

.popup {
    // &.mobile {

    //     .van-popup {
    //         &.van-popup--center {
    //             width: 100% !important;
    //             height: 100% !important;
    //             max-width: 100% !important;
    //             min-height: 100% !important;
    //             max-height: 100% !important;
    //         }

    //         .content {
    //             width: 100% !important;
    //             // padding-bottom: .4rem;
    //             height: 100% !important;

    //             .header {
    //                 height: .94rem;
    //                 padding: 0 .28rem;

    //                 &>div:first-child {
    //                     font-size: .3rem;
    //                 }

    //                 .close {
    //                     font-size: .3rem;
    //                 }
    //             }
    //         }
    //     }
    // }

    .van-popup {
        background: transparent;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        width: 100%;

        .content {
            background: $bg-popup-color;
            width: 94%;
            max-width: 500px;
            // height: 700px;
            border-radius: .24rem;
            overflow: hidden;
            display: flex;
            flex-direction: column;

            .header {
                display: flex;
                height: 1rem;
                padding: 0 .3rem;
                padding-top: .18rem;
                display: flex;
                align-items: center;
                justify-content: space-between;
                // background: $bg-popup-navbar-color;

                &>div:first-child {
                    font-size: .3rem;
                    font-weight: bold;
                    color: $font-color;
                }

                .close {
                    color: $font-iconfont-color;
                    font-size: .42rem;
                    font-weight: bold;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    transition: all 0.3s;

                    &:hover {
                        color: $font-color;
                        rotate: -180deg;
                    }
                }
            }

            .info_box {
                border-radius: .32rem;

                .withdral_input_item {
                    padding: 0 .28rem;
                    padding-top: .08rem;

                    .input_title {
                        padding: .26rem 0;
                        font-size: .28rem;
                        color: $font-color;
                        line-height: .36rem;
                        position: relative;

                        .eyes {
                            position: absolute;
                            width: .42rem;
                            height: .42rem;
                            top: .2rem;
                            right: .1rem;

                            &>img {
                                width: .4rem;
                                height: .4rem;
                                vertical-align: middle;
                            }
                        }
                    }
                }
            }

            .withdraw_Tips {
                padding: 0 .28rem;
                padding-top: .32rem;
                padding-bottom: .14rem;

                .Tips {
                    color: $font-label-color;
                    font-size: .24rem;
                    line-height: .28rem;
                    letter-spacing: .02rem;
                }

                .forget_txt {
                    color: $font-theme-color;
                    font-size: .24rem;
                    line-height: .28rem;
                    text-align: left;
                    margin-top: .32rem;
                    cursor: pointer;
                }
            }

            .action_btn {
                height: .7rem;
                background: $bg-btn-color;
                border-radius: .64rem;
                margin: .6rem .28rem;
                margin-bottom: .2rem;
                font-family: eryawenrunti;
                font-size: .3rem;
                color: $font-btn-color;
                text-align: center;
                line-height: .7rem;
                cursor: pointer;

                &.disabled {
                    background: $bg-component-disabled-solid-color;
                    color: rgba(255, 255, 255, 0.45);
                    cursor: not-allowed;
                    box-shadow: 0 .06rem 0 0 $shadow-component-base-color, 0 .02rem .03rem 0 $border-component-deep-color, 0 .02rem .03rem 0 $font-component-pale-color;
                }
            }
        }
    }
}
</style>
